import React, { useState, useEffect } from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, 
  CCard, CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import OrderInputs from '../../components/OrderInputs/OrderInputs';
import { addOrderRequest } from '../../store/order/orderActions';

const CreateOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.orderReducer.isLoading);
  const submitResponse = useSelector(state => state.orderReducer.addOrderData);
  const [initialData, setInitialData] = useState(null);
  const [currentOrderNo, setCurrentOrderNo] = useState(null);

  useEffect(() => {
    if (location.state?.generatedOrderNo) {
      const orderNo = location.state.generatedOrderNo;
      setCurrentOrderNo(orderNo);
      setInitialData({
        OrderNo: orderNo
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (currentOrderNo && !initialData?.OrderNo) {
      setInitialData({
        OrderNo: currentOrderNo
      });
    }
  }, [currentOrderNo, initialData]);

  const handleSubmit = (data) => {
    dispatch(addOrderRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/orders');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/orders" 
        onClick={e => { e.preventDefault(); handleCancel(); }}>{t('orders')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createOrder')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createOrder')}</h4></CCardHeader>
            <CCardBody>
              <OrderInputs onSubmit={handleSubmit}
               onCancel={handleCancel} isLoading={isLoading} 
               submitResponse={submitResponse} initialData={initialData} />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default CreateOrder; 